export const sidebarMenu = [
    {
        name: "accueil",
        linkTo: "/",
        icon: "/img/menu/home.svg",
        roles: [1, 2, 3, 4, 5],
        subMenu: []
    },
    {
        name: "finances",
        linkTo: "/finances",
        icon: "/img/menu/money.svg",
        roles: [1, 2],
        subMenu: [
            {
                name: "comptes",
                linkTo: "/finances/accounts",
            },
            {
                name: "comptes_ibanfirst",
                linkTo: "/finances/accounts-ibanfirst",
            },
            {
                name: "payouts",
                linkTo: "/finances/payouts",
            },
            {
                name: "depots_externes",
                linkTo: "/finances/external-deposit",
            },
            {
                name: "iban",
                linkTo: "/finances/iban",
            },
            {
                name: "transactions",
                linkTo: "/finances/trades",
            },
            {
                name: "ordres",
                linkTo: "/finances/orders",
            },
            {
                name: "problemes",
                linkTo: "/finances/problems",
            },
            {
                name: "manual_payout",
                linkTo: '/finances/manual-payout'
            },
            {
                name: "investment_plans",
                linkTo: '/finances/investment-plans'
            },
            {
                name: "features",
                linkTo: '/finances/features'
            },
            {
                name: "margin_transactions",
                linkTo: '/finances/margin-transactions'
            },
            {
                name: "utility_bills",
                linkTo: "/finances/utility-bills",
            }
        ]
    },
    {
        name: "structured",
        linkTo: "/structured-products",
        icon: "/img/menu/posts.svg",
        roles: [1, 2],
        subMenu: [
            {
                name: "sp_products",
                linkTo: "/structured-products",
            },
            {
                name: "sp_drafts",
                linkTo: "/structured-products/drafts",
            },
            {
                name: "sp_issues",
                linkTo: "/structured-products/issues",
            },
        ]
    },
    {
        name: "cadeaux",
        linkTo: "/gifts",
        icon: "/img/menu/gifts.svg",
        roles: [1, 2, 3],
        subMenu: [
            {
                name: 'gifts',
                linkTo: '/gifts/list'
            },
            {
                name: 'gift',
                linkTo: '/gifts/new',
                roles: [1, 2]
            },
            {
                name: 'discount',
                linkTo: '/gifts/discount',
                roles: [1, 2]
            }
        ]
    },
    {
        name: "actifs",
        linkTo: "/actifs",
        icon: "/img/menu/finances.svg",
        roles: [1, 2],
        subMenu: [
            {
                name: "alpaca",
                linkTo: "/actifs/alpaca",
            },
            {
                name: "truelayer",
                linkTo: "/actifs/truelayer",
            },
            {
                name: "categories",
                linkTo: "/actifs/categories",
            },
            {
                name: "tickers",
                linkTo: "/actifs/tickers",
            },
            {
                name: "new_ticker",
                linkTo: "/actifs/tickers/new",
            },
            {
                name: "add_margin_ticker",
                linkTo: "/actifs/tickers/add_margin",
            },
            {
                name: "tickers_non_trouves",
                linkTo: "/actifs/tickers/not-found",
            },
            {
                name: "etf_edition",
                linkTo: "/actifs/etf/edit",
            },
            {
                name: "reconciliations",
                linkTo: "/actifs/reconciliations",
            },
        ]
    },
    {
        name: "users",
        linkTo: "/users",
        icon: "/img/menu/usersIcon.svg",
        roles: [1, 2, 3, 4],
        subMenu: [
            {
                name: "users_list",
                linkTo: "/users/list",
            },
            {
                name: "analytics",
                linkTo: "/users/analytics",
            },
            {
                name: "deleted_users",
                linkTo: "/users/deleted/list",
            }
        ]
    },
    {
        name: "copy_invest",
        icon: "/img/menu/usersIcon.svg",
        linkTo: "/copy-invest",
        roles: [1, 2, 3],
        subMenu: []
    },
    {
        name: "fees",
        icon: "/img/menu/money.svg",
        linkTo: "/fees",
        roles: [1, 2],
        subMenu: []
    },
    {
        name: "campaign_list",
        icon: "/img/menu/usersIcon.svg",
        linkTo: "/campaigns/list",
        roles: [1, 2],
        subMenu: []
    },
    {
        name: "bots",
        icon: "/img/menu/usersIcon.svg",
        linkTo: "/bots",
        roles: [1, 2],
        subMenu: [],
    },
    {
        name: "b_book",
        icon: "/img/menu/usersIcon.svg",
        linkTo: "/b-book",
        roles: [1, 2],
        subMenu: [
            {
                name: "b_book_pnl",
                linkTo: "/b-book/pnl",
            },
            {
                name: "b_book_moves",
                linkTo: "/b-book/moves",
            },
            {
                name: "b_book_report",
                linkTo: "/b-book/a-vs-b",
            },
            {
                name: "b_book_settings",
                linkTo: "/b-book",
            },
        ]
    },
    {
        name: "ago",
        icon: "/img/menu/usersIcon.svg",
        roles: [1, 2, 3],
        subMenu: [
            {
                name: "ago_users_list",
                linkTo: "/ago/users",
            },
            {
                name: "ago_deposits",
                linkTo: "/ago/deposits",
            },
            {
                name: "ago_payouts",
                linkTo: "/ago/payouts",
            },
            {
                name: "ago_transactions",
                linkTo: "/ago/transactions",
            }

        ]

    },
    {
        name: "posts",
        icon: "/img/menu/posts.svg",
        roles: [1, 2, 5],
        subMenu: [
            {
                name: "posts_list",
                linkTo: "/posts",
            },
            {
                name: "paradox_posts_list",
                linkTo: "/paradox-posts",
                roles: [1, 2]
            },
            {
                name: "muted_users",
                linkTo: "/posts/muted-users",
                roles: [1, 2]
            }
        ]
    },
    {
        name: "paradox",
        linkTo: "/paradox",
        icon: "/img/menu/posts.svg",
        roles: [1, 2],
        subMenu: []
    },
    {
        name: "playlists",
        linkTo: "/playlists",
        icon: "/img/menu/posts.svg",
        roles: [1, 2],
        subMenu: []
    },
    {
        name: "notifications",
        linkTo: "/notifications",
        icon: "/img/menu/posts.svg",
        roles: [1, 2, 4, 5],
        subMenu: []
    },
    {
        name: "rapports",
        linkTo: "/reports",
        icon: "/img/menu/reports.svg",
        roles: [1, 2, 3],
        subMenu: [
            {
                name: "users",
                linkTo: "/reports/users",
            },
            {
                name: "trades",
                linkTo: "/reports/trades",
            },
            {
                name: "money",
                linkTo: "/reports/money",
            },
            {
                name: "compliance",
                linkTo: "/reports/compliance",
            },
            {
                name: "agbk_reports",
                linkTo: "/reports/agbk-compliance",
            },
            {
                name: "accounts",
                linkTo: "/reports/accounts",
            },
            {
                name: "sumsub",
                linkTo: "/reports/sumsub-screening",
            },
            {
                name: "transactions_reporting",
                linkTo: "/reports/trs",
            },
            {
                name: "subscriptions",
                linkTo: "/reports/subscriptions",
            }
        ]
    },
    {
        name: "queues",
        linkTo: "/queues",
        icon: "/img/menu/reports.svg",
        roles: [1, 2],
        subMenu: [
            {
                name: "dlq",
                linkTo: "/queues/dlq",
            },
            {
                name: "nta",
                linkTo: "/queues/nta",
            }
        ]
    },
    {
        name: "tools",
        icon: "/img/menu/reports.svg",
        roles: [1, 2],
        subMenu: [
            {
                name: "marketing",
                linkTo: "http://marketing.goliaths.io/",
            },
            {
                name: "reconciliations",
                linkTo: "http://reconciliation.goliaths.io/",
            },
            {
                name: "debug",
                linkTo: "http://debug.goliaths.io/",
            }
        ]
    },
]